export const API_URL = "https://api.ghinashop.net/best-price/api/v0" ;
export const API_KEY = "ADFRETYUUBFD!#@%*%4455iup!98SCZ@"